import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import DonutChartTemplate from "views/molecules/charts/template/DonutChartTemplate"
import { useAppContext } from "components/AppContext"
import { useEntity } from "hooks/useAxios"
import useRequest from "hooks/useRequest"
import ScoreEntity from "services/entities/ScoreEntity"
import Loading from "components/widgets/Loading"

const ChartODD13GHGEmissionsBreakdownPurchasesByAllocationMolecule = () => {
  const { t } = useTranslation()
  const translationPrefix = `score:score.13.purchaseChartGHGBreakdownByAllocation`
  const { currentNode, currentPeriod } = useAppContext()
  const scoreEntity = useEntity(ScoreEntity)
  const { data, isLoading, reload } = useRequest(
    () => scoreEntity.getOdd13GhgEmissionsBreakdownByAllocation(),
    [currentNode, currentPeriod],
    {
      condition: !!currentNode && currentNode?.has_purchases,
      cacheKey: `odd13-allocation-${currentNode?.id}-${currentPeriod?.id}`,
    }
  )
  if (isLoading) {
    return <Loading />
  }

  if (!data) return null

  return (
    <DonutChartTemplate
      title={t(`${translationPrefix}.title`)}
      data={data.data}
      labelKeys={data.label_keys}
      unitPath={"units:units.emission"}
      unitKey={data.unit_key}
      helpText={t(`${translationPrefix}.help`)}
    />
  )
}

export default ChartODD13GHGEmissionsBreakdownPurchasesByAllocationMolecule
